(function () {
  var root = document.getElementById('PpProd');
  if (!root || !window.JSON) return;
  var data = JSON.parse(document.getElementById('PpProdData').textContent);
  var form = root.querySelector('form.pp-form');
  var vid = form.querySelector('[data-vid]');
  var btn = root.querySelector('[data-atc]');
  var qty = root.querySelector('[data-qty]');
  var track = root.querySelector('[data-track]');
  var thumbs = root.querySelectorAll('[data-thumb]');
  var slides = root.querySelectorAll('[data-slide]');
  var hasOpts = root.querySelectorAll('.pp-opt').length > 0;
  var fmt = function (c) { return '$' + (c / 100).toFixed(2); };
  var state = data.variants.filter(function (v) { return String(v.id) === vid.value; })[0] || data.variants[0];

  function opts() {
    var a = [];
    root.querySelectorAll('.pp-opt').forEach(function (f) {
      var c = f.querySelector('input:checked');
      a.push(c ? c.value : null);
    });
    return a;
  }
  function find(o) {
    return data.variants.filter(function (v) {
      return v.options.every(function (x, i) { return x === o[i]; });
    })[0];
  }
  function go(i) { if (track) track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' }); }
  function active(i) {
    thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === i); });
    var c = root.querySelector('[data-count]');
    if (c) c.textContent = (i + 1) + ' / ' + slides.length;
  }
  if (track) {
    track.addEventListener('scroll', function () {
      clearTimeout(track._t);
      track._t = setTimeout(function () { active(Math.round(track.scrollLeft / track.clientWidth)); }, 60);
    });
  }
  thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
  root.querySelectorAll('[data-arrow]').forEach(function (a) {
    a.addEventListener('click', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth) + Number(a.dataset.arrow);
      go(Math.max(0, Math.min(slides.length - 1, i)));
    });
  });

  var sticky = root.querySelector('[data-sticky]');
  var stickyBtn = root.querySelector('[data-sticky-btn]');
  function label() {
    btn.querySelector('[data-atc-label]').textContent = state.available ? 'Add to cart' : 'Sold out';
    btn.disabled = !state.available;
    var r = root.querySelector('[data-restock]');
    if (r) r.hidden = state.available;
    stickyBtn.textContent = state.available ? 'Add to cart' : 'Sold out';
    stickyBtn.disabled = !state.available;
  }
  function refresh() {
    var o = opts();
    var v = hasOpts ? find(o) : data.variants[0];
    root.querySelectorAll('.pp-opt').forEach(function (f, i) {
      f.querySelector('[data-optval]').textContent = o[i];
      f.querySelectorAll('input').forEach(function (inp) {
        var t = o.slice();
        t[i] = inp.value;
        var vv = find(t);
        inp.parentNode.classList.toggle('is-out', !(vv && vv.available));
      });
    });
    if (!v) {
      btn.disabled = true;
      btn.querySelector('[data-atc-label]').textContent = 'Unavailable';
      return;
    }
    state = v;
    vid.value = v.id;
    root.querySelector('[data-price]').textContent = fmt(v.price);
    var c = root.querySelector('[data-compare]');
    if (v.compare_at_price && v.compare_at_price > v.price) { c.textContent = fmt(v.compare_at_price); c.hidden = false; } else { c.hidden = true; }
    label();
    if (v.featured_image) {
      for (var i = 0; i < slides.length; i++) {
        if (String(slides[i].dataset.imgId) === String(v.featured_image.id)) { go(i); break; }
      }
    }
    if (hasOpts && history.replaceState) history.replaceState(null, '', '?variant=' + v.id);
  }
  root.querySelectorAll('.pp-opt input').forEach(function (i) { i.addEventListener('change', refresh); });
  root.querySelectorAll('[data-q]').forEach(function (b) {
    b.addEventListener('click', function () { qty.value = Math.max(1, (Number(qty.value) || 1) + Number(b.dataset.q)); });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (!state.available) return;
    var l = btn.querySelector('[data-atc-label]');
    btn.classList.add('is-busy');
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: state.id, quantity: Number(qty.value) || 1 }] })
    })
      .then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || 'Could not add'); return j; });
      })
      .then(function () {
        l.textContent = 'Added!';
        setTimeout(label, 1400);
        if (window.ppCart) { window.ppCart.refresh(true); } else { location.href = '/cart'; }
      })
      .catch(function (err) { l.textContent = 'Try again'; setTimeout(label, 1800); console.warn(err); })
      .then(function () { btn.classList.remove('is-busy'); });
  });

  var modal = root.querySelector('[data-modal]');
  var help = root.querySelector('[data-sizehelp]');
  if (help) help.addEventListener('click', function () { modal.hidden = false; });
  modal.addEventListener('click', function (e) { if (e.target === modal || e.target.hasAttribute('data-close')) modal.hidden = true; });

  stickyBtn.addEventListener('click', function () { if (form.requestSubmit) form.requestSubmit(); else btn.click(); });
  if ('IntersectionObserver' in window) {
    new IntersectionObserver(function (en) {
      sticky.hidden = !(!en[0].isIntersecting && en[0].boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(btn);
  }

  var bases = root.querySelector('[data-bases]');
  function paint(cart) {
    if (!bases) return;
    var elig = JSON.parse(root.dataset.elig);
    var need = Number(root.dataset.items) || 3;
    var n = 0;
    cart.items.forEach(function (i) { if (elig.indexOf(i.handle) > -1) n += i.quantity; });
    var on = Math.min(n, 3);
    [1, 2, 3].forEach(function (k) { bases.querySelector('.b' + k).classList.toggle('on', k <= on); });
    var msg = bases.querySelector('[data-bases-msg]');
    if (n >= need) msg.textContent = 'Bases loaded! Your free pair is in the cart.';
    else if (n > 0) msg.textContent = n + ' of ' + need + ' in your cart. Add ' + (need - n) + ' more and the last one is free.';
  }
  if (window.ppCart) window.ppCart.on(paint);
  refresh();
})();